import {StockFunctions} from '../../../shared-utilities/functions-old/stock-functions';
import {StockItem, VatRates} from '../../../shared-utilities/models-old/datastructures';
import {IStore} from '../../../shared/shared-models/store/store';

/**
 * Resolves the VAT rate for a stock item from store defaults or loaded conversion data.
 */
export function getQuoteStockItemVatRate(
  item: StockItem,
  store: IStore,
  vatRates?: VatRates,
): number | undefined {
  const vatKey = item?.vatR;
  if (!vatKey) {
    return undefined;
  }

  const storeVatRates = StockFunctions.getVatRateForStore(store.storeId);
  const resolvedRate = storeVatRates?.[vatKey]?.vatRate ?? vatRates?.[vatKey]?.vatRate;
  return resolvedRate != null && Number.isFinite(resolvedRate) ? resolvedRate : undefined;
}
